import { useRef, useState } from "react";
import {
  IonModal,
  IonHeader,
  IonContent,
  IonToolbar,
  IonTitle,
} from "@ionic/react";
import closeIcon from "../../assets/imgs/close.svg";
import { useSelector } from "react-redux";
import { actions } from "../../Redux/store";
import leagueSettingsBg from "../../assets/imgs/league-settings-bg.svg";
import LeagueSettingsItem from "./Componet/LeagueSettingsItem";
import CounterControl from "./Componet/CounterControl";
import { useRevenueCatAuth } from "../../Context/RevenueCatContext/RevenueCatContext";
import { useNavigate } from "react-router-dom";
import { hapticsImpactLight } from "../../lib/utils";
import { SelectLeagueButton } from "../LeagueSync/SelectLeagueButton/SelectLeagueButton";
import { useLeagueStore } from "../../zustandStore/leagueStore";

// Common component for counter items
interface RosterCounterItemProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  max?: number;
}

function RosterCounterItem({ label, value, onChange, max }: RosterCounterItemProps) {
  return (
    <div className="flex items-center justify-between mt-2 cursor-pointer">
      <div>
        <span className="text-white text-[12px] font-medium">{label}</span>
      </div>
      <CounterControl value={value} onChange={onChange} max={max} />
    </div>
  );
}

export default function LeagueSettingsModal() {
  const modal = useRef<HTMLIonModalElement>(null);
  const isOpen = useSelector(
    (sate: any) => sate.modal.leagueSettingsModal?.open,
  );
  const navigate = useNavigate();
  const { isSubscribed } = useRevenueCatAuth();
  const toggle = () => {
    actions.modal.closeLeagueSettingsModal(null);
  };
  const { LeagueType,ScoringFormat } = useLeagueStore();
  function dismiss() {
    modal.current?.dismiss();
    toggle();
  }

  const [teamCount, setTeamCount] = useState(12);

  // Function to handle team count changes with haptic feedback
  const handleTeamCountChange = (newValue: number) => {
    hapticsImpactLight();
    setTeamCount(newValue);
  };

  // Roster positions array with their counts
  const [rosterPositions, setRosterPositions] = useState([
    { id: "qb", label: "QB", value: 1 },
    { id: "rb", label: "RB", value: 2 },
    { id: "wr", label: "WR", value: 2 },
    { id: "te", label: "TE", value: 1 },
    { id: "flex", label: "FLEX", value: 1 },
    { id: "super", label: "SUPERFLEX", value: 0 },
    { id: "k", label: "K", value: 1 },
    { id: "def", label: "DEF/ST", value: 1 },
  ]);

  // Function to update a specific roster position count
  const updateRosterPosition = (id: string, newValue: number) => {
    hapticsImpactLight();
    setRosterPositions((prevPositions) =>
      prevPositions.map((position) =>
        position.id === id ? { ...position, value: newValue } : position,
      ),
    );
  };

  const clickLearnMore = () => {
    hapticsImpactLight();
    navigate("/chatbot-paywall-v2");
    dismiss();
    actions.modal.closeTradeAnalyzerModal(null);
  };

  const opneLeagueTypeModal = () => {
    hapticsImpactLight();
    actions.modal.openLeagueTypeModal(null);
  };

  const openScoringFormat = () => {
    hapticsImpactLight();
    actions.modal.openScoringFormatModal(null);
  };
  return (
    <IonModal
      onDidDismiss={dismiss}
      className={`full-modal`}
      isOpen={isOpen}
      backdropDismiss={false}
      ref={modal}
    >
      <>
        <IonHeader class="ion-no-border modal-ion-header">
          <IonToolbar className="custom-toolbar mt-[10px]">
            <div className="p-2 px-3 flex justify-between items-center sticky top-0 z-50">
              <div
                onClick={dismiss}
                className="flex items-center justify-center w-[32px] h-[32px] bg-white/10 rounded-full cursor-pointer"
              >
                <img
                  src={closeIcon}
                  alt="close"
                  className="w-[12.4px] h-[12.4px]"
                />
              </div>
              <IonTitle>
                <div className="flex flex-row items-center justify-center">
                  <span className=" [@media(min-width:375px)]:text-[22px] text-[20px] font-medium text-white">
                    League Settings
                  </span>
                </div>
              </IonTitle>
            </div>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <div className="px-[20px] pb-6">
            {!isSubscribed ? (
              <div
                className="w-full flex items-center justify-center  cursor-pointer mt-2"
                onClick={clickLearnMore}
              >
                <div className="relative flex items-center justify-center w-full max-w-[576px] mx-auto">
                  <img
                    src={leagueSettingsBg}
                    alt="Rotobot AI PRO"
                    className="w-full object-cover rounded-[10px]"
                  />
                  <div
                    className="absolute inset-0 p-[10px] pb-[13px] text-center w-full flex flex-col justify-between rounded-[10px]"
                    style={{
                      background:
                        "linear-gradient(280.83deg, rgba(59, 66, 171, 0) 0%, #04133A 98.4%)",
                    }}
                  >
                    <div className="space-y-2 text-start">
                      <h2 className=" font-bold text-white flex gap-2 items-center  text-[20px] pl-2">
                        rotobot ai{" "}
                        <span className="inline-flex items-center justify-center rounded-md bg-white h-[22px] w-[40px]  text-[12px] text-primary font-extrabold">
                          PRO
                        </span>
                      </h2>
                      <div>
                        <p className="text-white/70 text-[11px] font-medium">
                          Upgrade to get access to sync league.
                        </p>
                        <p className="text-white/70 text-[11px] font-medium">
                          Get any question about your team answered.
                        </p>
                      </div>
                    </div>
                    <button className="text-[10px] text-black font-medium bg-white  hover:bg-white/90 [@media(min-width:375px)]:h-[34.75px]  rounded-[22.75px] h-[25px] mx-[20px]">
                      Learn More
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <>
                {/* <div className="flex items-center justify-center mt-[-8px]">
                  <SelectLeagueButton />
                </div> */}
              </>
            )}

            <div className="mt-5">
              <span className="text-white/75 text-[12px] font-normal">
                League Settings
              </span>

              <div className="flex-col space-y-4">
                <div onClick={opneLeagueTypeModal}>
                  <LeagueSettingsItem label={"League Type"} value={LeagueType?.showingName || "Redraft"} />
                </div>
                <RosterCounterItem
                  label="Teams"
                  value={teamCount}
                  onChange={handleTeamCountChange}
                />

                <div className="flex-col space-y-3" onClick={openScoringFormat}>
                  <LeagueSettingsItem label={"Scoring"} value={ScoringFormat?.name || "PPR"} />
                </div>
              </div>
            </div>

            <div className="mt-8">
              <span className="text-white/75 text-[12px] font-normal">
                Your Roster
              </span>

              <div className="flex-col space-y-5">
                {rosterPositions.map((position) => (
                  <RosterCounterItem
                    key={position.id}
                    label={position.label}
                    value={position.value}
                    onChange={(newValue) =>
                      updateRosterPosition(position.id, newValue)
                    }
                    max={5}
                  />
                ))}
              </div>
            </div>
          </div>
        </IonContent>
      </>
    </IonModal>
  );
}
